import React from 'react';
import { Table, Button, message, Select, Modal } from 'antd';
import { getToken, deleteToken } from '../../common/fetch';
import { TABLE_TOKEN_COLUMN } from '../../config/constants';
import { TokenWrapper } from './style';
import ContactUs from '../../components/ContactUs';
import UpgradeModal from '../../components/UpgradeModal';
import NewToken from '../NewToken';

class TokenList extends React.Component {
	state = {
		data: [],
		pagination: {},
		visible: false,
		loading: false,
		isUpgrade: false,
		filter: 'active',
		isOpenNewToken: false
	};

	isReady = true;

	componentDidMount() {
		this.getToken();
	}

	componentWillReceiveProps(next) {
		const { location, history } = next;
		const pathArr = location.pathname.split('/');
		const token_id = parseInt(pathArr[pathArr.length - 1], 10);

		if (!isNaN(token_id) && this.isReady) {
			this.isReady = false;
			Modal.confirm({
				title: 'Do you want to revoke api key?',
				content: 'When clicked the OK button, The api key is revoked.',
				onOk: () => {
					this.revokeToken(token_id);
				},
				onCancel: () => {
					this.isReady = true;
					history.goBack();
				}
			});
		}
	}

	revokeToken = async (token_id) => {
		try {
			const body = {
				token_id
			};
			await deleteToken(body);
			this.isReady = true;
			this.setState(
				{
					data: this.state.data.filter((item) => item.id !== token_id)
				},
				this.props.history.goBack
			);
		} catch (error) {
			console.error(error);
		}
	};

	getToken = (params = {}) => {
		this.setState({ loading: true }, async () => {
			try {
				const res = await getToken();
				this.setState({ loading: false, data: res.data.data });
			} catch (error) {
				this.setState({ loading: false });
			}
		});
	};

	handleClick = async (e, record) => {
		if (e.target.className.indexOf('active') >= 0) {
			this.setState({ visible: true });
		}
	};

	handleSelect = (v) => {
		this.setState({ filter: v });
	};

	handleOk = (body) => {
		message.success(body);
		this.handleCancel();
	};

	handleError = (body) => {
		message.error(body);
		this.handleCancel();
	};

	handleCancel = () => {
		this.setState({ visible: false });
	};

	createToken = () => {
		// NOTE Free to restriction.
		// const { verification_level } = this.props.user;
		// if (verification_level >= 3) {
		// 	this.setState({ isOpenNewToken: true });
		// } else {
		// 	this.setState({ isUpgrade: true });
		// }
		this.setState({ isOpenNewToken: true });
	};

	closeModal = () => {
		this.setState({ isUpgrade: false });
	};

	checkFilter = (obj) => {
		const { filter } = this.state;
		if (filter === '') {
			return true;
		} else if (filter === 'active') {
			return obj.active === true;
		} else if (filter === 'revoked') {
			return obj.revoked === true;
		} else if (filter === 'inactive') {
			return obj.active === false && obj.revoked === false;
		}
		return true;
	};

	render() {
		const {
			data,
			loading,
			visible,
			isUpgrade,
			filter,
			isOpenNewToken
		} = this.state;
		const tokenData = data.filter(this.checkFilter);

		return (
			<TokenWrapper>
				<h2>
					<b>API KEY</b>
				</h2>
				<p>Create an API key and build programs on top of your wallet.</p>
				<div className="button-wrapper">
					<Select value={filter} onChange={this.handleSelect}>
						<Select.Option value="">All</Select.Option>
						<Select.Option value="active">Active</Select.Option>
						<Select.Option value="inactive">Inactive</Select.Option>
						<Select.Option value="revoked">Revoked</Select.Option>
					</Select>
					<Button type="primary" onClick={this.createToken}>
						{/* <Link to="/product/vault/token/new">Generate Token</Link> */}
						Generate API Key
					</Button>
				</div>
				<div className="holla-table-wrapper">
					<Table
						columns={TABLE_TOKEN_COLUMN}
						rowKey={(record) => record.id}
						dataSource={tokenData}
						loading={loading}
						pagination={false}
						onRow={(record) => {
							return {
								onClick: (e) => {
									this.handleClick(e, record);
								}
							};
						}}
					/>
				</div>
				<ContactUs
					visible={visible}
					defaultType="API Keys"
					handleOk={this.handleOk}
					handleError={this.handleError}
					handleCancel={this.handleCancel}
				/>
				<UpgradeModal
					visible={isUpgrade}
					step={1}
					handleError={this.closeModal}
					handleCancel={this.closeModal}
					handleOk={this.closeModal}
				/>
				{isOpenNewToken && (
					<NewToken
						visible={isOpenNewToken}
						onOk={() => {
							this.setState({ isOpenNewToken: false }, this.getToken);
						}}
						onCancel={() => {
							this.setState({ isOpenNewToken: false });
						}}
					/>
				)}
			</TokenWrapper>
		);
	}
}

export default TokenList;
